import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type SheetKind = 'sos' | 'messages' | 'booking' | null;

interface UiState {
  sheet: SheetKind;
  toast: { text: string; tone: 'ok' | 'error' } | null;
  /** 传输中提示（预约提交、授权切换等需要即时反馈） */
  busyKey: string | null;
  openSheet: (sheet: Exclude<SheetKind, null>) => void;
  closeSheet: () => void;
  showToast: (text: string, tone?: 'ok' | 'error') => void;
  clearToast: () => void;
  setBusy: (key: string | null) => void;
  /** 上次查看的 AI 会话，跨刷新保留 */
  lastAiSessionId: string | null;
  setLastAiSession: (id: string) => void;
}

export const useUi = create<UiState>()(
  persist(
    (set) => ({
      sheet: null,
      toast: null,
      busyKey: null,
      lastAiSessionId: null,
      openSheet: (sheet) => set({ sheet }),
      closeSheet: () => set({ sheet: null }),
      showToast: (text, tone = 'ok') => set({ toast: { text, tone } }),
      clearToast: () => set({ toast: null }),
      setBusy: (busyKey) => set({ busyKey }),
      setLastAiSession: (lastAiSessionId) => set({ lastAiSessionId }),
    }),
    {
      name: 'hew3.ui',
      // 只持久化「上次会话」，sheet / toast 属于瞬时状态，不应跨刷新保留
      partialize: (state) => ({ lastAiSessionId: state.lastAiSessionId }),
    },
  ),
);
